import { ProductGroupReducer } from "../reducer/ProductGroupReducer";

export const reducer = ProductGroupReducer;